import React, { useRef } from 'react'
import injectSheet from 'react-jss'
import SlideFooter from '../slide-footer/slide-footer.container'
import { Presentation } from 'pobble-components/dist/presentation'
import { EditSlidePanel } from '../edit-slide-panel/edit-slide-panel'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  layoutContent: {
    flex: '1',
    marginTop: '1px'
  },
  footer: {
    paddingTop: '40px'
  },
  restrictedOverlay: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    zIndex: '5',
    cursor: 'pointer'
  },
  slideContainer: {
    boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.16)'
  },
  slideWrapper: {
    position: 'relative',
    transition: 'box-shadow 0.2s ease-out',
    '@supports (aspect-ratio: 1 / 1)': {
      maxHeight: 'calc(100vh - 180px)',
      aspectRatio: '16 / 9',
      margin: '0 auto'
    },
    '&:hover': {
      boxShadow: '0 0 0 4px var(--light-gray), 0 0 0 6px var(--gray)',
      '& $quickActionsPanel': {
        opacity: '1',
        transform: 'scale(1)'
      }
    }
  },
  quickActionsPanel: {
    position: 'absolute',
    top: '-20px',
    left: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    opacity: '0',
    transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
    transform: 'scale(.95)',
    zIndex: '10'
  }
}

const SlideConstructor = ({
  classes,
  id,
  presentation,
  slides,
  activeSlideId,
  onSlideUpdate
}) => {
  const containerRef = useRef(null)

  return (
    <Presentation
      onSlideUpdate={onSlideUpdate}
      data={presentation}
      slides={slides}
      slideContainerClassName={classes.slideContainer}
      activeSlideId={activeSlideId}
      containerRef={containerRef}
      builder>
      {({ currentSlide, slideData, slides }) => {
        return (
          <div className={classes.container}>
            <div className={classes.layoutContent}>
              <div className={classes.slideWrapper} ref={containerRef}>
                <div className={classes.quickActionsPanel}>
                  <EditSlidePanel slideData={slideData} />
                </div>
                {currentSlide}
              </div>
              {!presentation.asset && (
                <div className={classes.footer}>
                  <SlideFooter key={id} id={id} />
                </div>
              )}
            </div>
          </div>
        )
      }}
    </Presentation>
  )
}

export default injectSheet(styles)(SlideConstructor)
